import { createStandardAction } from 'typesafe-actions';

export const setStudentsStatus = createStandardAction(
  'CLASSDIGITALNOTEBOOK/SET_STUDENTS_STATUS'
)<{ [studentId: string]: string[] }>();
